export default "__VITE_ASSET__3debb940__"